import { useState } from "react";
import axios from "axios";
import { message } from "antd";
import { adminService } from "../../../../../configs/constants";

interface ServiceRequestValues {
  name?: { label: string; value: string };
  commercialCategories?: { label: string; value: string }[];
  residentialCategories?: { label: string; value: string }[];
}

export const usePostGeneralServiceRequest = () => {
  const [loading, setLoading] = useState(false);

  const postGeneralServiceRequest = async (values: ServiceRequestValues) => {
    try {
      if (
        !values?.commercialCategories?.length &&
        !values?.residentialCategories?.length
      ) {
        message.error(
          "Please select at least one service (Residential or Commercial)"
        );
        return false;
      }

      setLoading(true);

      // Build payload
      const payload: Record<string, any> = {
        orgId: values?.name?.value,
      };

      payload.commercialCategories = values.commercialCategories.map(
        (item) => item?.value
      );
      payload.residentialCategories = values.residentialCategories.map(
        (item) => item?.value
      );

      // POST request
      const { data } = await axios.post(
        `${adminService}/general-services/assign`,
        payload
      );

      message.success("General service request submitted successfully!");
      return data;
    } catch (error: any) {
      console.error("Error posting general service request:", error);
      message.error(
        error?.response?.data?.message ||
          "Failed to submit general service request"
      );
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { postGeneralServiceRequest, loading };
};
